/*
工单统计
 */
import React, { Component } from "react";
import Echarts from "echarts";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import Tool from "@/utils/Tool";
import { Spin, Button, Tooltip } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";

import ExportJsonExcel from 'js-export-excel';
import { RightOutlined } from "@ant-design/icons";
class TicketNumCount extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [
      //   {id:2,text:"东区", choosed:2}, 
      // {id:3,text:"东区", choosed:1}, 
      // {id:4,text:"东区", choosed:1}, 
      // {id:5,text:"东区", choosed:1}, 
      // {id:6,text:"东区", choosed:1}
    ],
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {

    console.info('触发我5')
    var gridDataNew = [];
    this.setState(
      {
        gridData: gridDataNew,
      },
      () => {
        // 默认加载
      this.stubIntactChart();
      },
    );
    
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    console.info('触发我3')
    this.initTableConfig();
  }

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {

      var gridDataNew = [];
      if (nextProps.dataSource && nextProps.dataSource.totalCount)
    {
      var xunRate = nextProps.dataSource.totalCount.xunNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.xunNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var cleanRate = nextProps.dataSource.totalCount.cleanNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.cleanNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var careRate = nextProps.dataSource.totalCount.careNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.careNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var tiaoate = nextProps.dataSource.totalCount.tiaoNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.tiaoNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var yanNumRate = nextProps.dataSource.totalCount.yanNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.yanNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var commonNumRate = nextProps.dataSource.totalCount.commonNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.commonNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var stubNumRate = nextProps.dataSource.totalCount.stubNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (nextProps.dataSource.totalCount.stubNum/nextProps.dataSource.totalCount.totalNum *100).toFixed(2))
      var lockNumRate = nextProps.dataSource.totalCount.lockNum == 0 ? 0 : (nextProps.dataSource.totalCount.totalNum == 0 ? 0 : (100 - xunRate - cleanRate - careRate - tiaoate - yanNumRate - commonNumRate - stubNumRate).toFixed(2))
      gridDataNew.push({
        text:'巡检工单',
        num:nextProps.dataSource.totalCount.xunNum,
        rate:xunRate,
      })
      gridDataNew.push({
        text:'清洁工单',
        num:nextProps.dataSource.totalCount.cleanNum,
        rate:cleanRate,
      })
      gridDataNew.push({
        text:'保养工单',
        num:nextProps.dataSource.totalCount.careNum,
        rate:careRate,
      })
      gridDataNew.push({
        text:'调试工单',
        num:nextProps.dataSource.totalCount.tiaoNum,
        rate:tiaoate,
      })
      gridDataNew.push({
        text:'验收工单',
        num:nextProps.dataSource.totalCount.yanNum,
        rate:yanNumRate,
      })
      gridDataNew.push({
        text:'通用工单',
        num:nextProps.dataSource.totalCount.commonNum,
        rate:commonNumRate,
      })
      gridDataNew.push({
        text:'充电桩故障工单',
        num:nextProps.dataSource.totalCount.stubNum,
        rate:stubNumRate,
      })
      gridDataNew.push({
        text:'地锁故障工单',
        num:nextProps.dataSource.totalCount.lockNum,
        rate:lockNumRate,
      })
    }
    this.setState(
      {
        gridData: gridDataNew,
      },
      () => {
        if (this.state.btnType === 1) {
          this.stubIntactChart();
        } else {
          this.initTableConfig();
        }
      },
    );
      
    }
  }

  /** */
  initTableConfig = () => {
    var dataSource = JSON.parse(localStorage.getItem('ticketBoardData'));
    this.setState({
      tableConfig: {
        tableKey: "ticketNumCountTable",
        tableColumns: [
          {
            name: "日期",
            key: "date",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单总数",
            key: "totalNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "巡检工单数",
            key: "xunNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "清洁工单数",
            key: "cleanNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "保养工单数",
            key: "careNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "调试工单数",
            key: "tiaoNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "验收工单数",
            key: "yanNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "通用工单数",
            key: "commonNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "充电桩故障工单数",
            key: "stubNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "地锁故障工单数",
            key: "lockNum",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart = () => {
    var dataSource = JSON.parse(localStorage.getItem('ticketBoardData'));
    // 数据设置
    let data = [];
    let dataLen = [];
    let colors = [];

    if (!dataSource || dataSource == null || dataSource.length === 0) {
      data = [{ name: "暂无数据", value: 0 }];
      dataLen = [];
      colors = ["#d8d8d8"];
    } else {
      let len = 0;
      if (dataSource.length > 8)
      {
        len = parseInt(dataSource.length/8);
      }
      // 数据
      dataSource.map((item, index) => {
        data.push(item.totalNum);
        if (len == 0 || index == 0 || index == (dataSource.length - 1) || (index + 1) % len == 0)
        {
          dataLen.push(item.date);
        } else {
          dataLen.push('');
        }
      });
    }
    const myChart = Echarts.init(
      document.getElementById(this.props.chartId || "ticketNum-page-char"),
    );
    const option = {
      // 图表背景颜色
      // backgroundColor: '#ccc',
      title: {
          text: '',
          left: "center",
          textStyle: {
              color: '#1e80ff',
              fontSize: 24,

          }
      },
      tooltip: {
          trigger: 'axis',
          formatter: function(data) 
          {
            var pieData = JSON.parse(localStorage.getItem('ticketBoardData'));
            var one = pieData[data[0].dataIndex]
            return one.date + '<br/>总工单数：' + one.totalNum + '<br/>巡检工单：'+ one.xunNum
            + '<br/>清洁工单：'+ one.cleanNum
            + '<br/>保养工单：'+ one.careNum
            + '<br/>调试工单：'+ one.tiaoNum
            + '<br/>验收工单：'+ one.yanNum
            + '<br/>通用工单：'+ one.commonNum
            + '<br/>充电桩故障工单：'+ one.stubNum
            + '<br/>地锁故障工单：'+ one.lockNum;
          }
      },
      legend: {
          data: [''],
          textStyle: {
              color: 'black',
          },
          orient: 'vertical',
          left: 'center',
          bottom:'bottom',
      },
      toolbox: {
          show: true,
          feature: {
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar'] },
              restore: { show: true },
              saveAsImage: { show: true }
          }
      },
      calculable: true,
      xAxis: [
          {
              name: '日期',
              nameTextStyle: {
                  padding: [20, 0, 0, 0],    // 四个数字分别为上右下左与原位置距离
                  // color:'green',
                  fontSize: 18,
              },
              type: 'category',
              // prettier-ignore
              data: dataLen,
              axisLabel: {
                  margin: 20,
                  interval: 0,
                  rotate: 20,
                  textStyle: {
                      //改变x轴上文字的颜色
                      // color: "green",
                      fontSize: 18,
                  }
              }
          }
      ],
      yAxis: [
          {
              name:'数量',
              nameTextStyle: {
                  padding: [20, 0, 0, 0],    // 四个数字分别为上右下左与原位置距离
                  color:'#1e80ff',
                  fontSize: 18,
              },

              type: 'value',
              axisLabel: {
                  textStyle: {
                      //改变y轴上文字的颜色
                      color: "#1e80ff",
                      fontSize: 18,
                  }
              },
              axisLine: {
                  show: true,//是否显示轴线
                  lineStyle: {
                      color: 'black',//刻度线的颜色
                  }
              }
          }
      ],
      series: [
          {
              name: '',
              type: 'bar',
              data: data,
              itemStyle: {
                  normal: {
                      color: '#1e80ff'
                  },
              },
              // markPoint: {
              //     data: [
              //         { type: 'max', name: 'Max' },
              //         { type: 'min', name: 'Min' }
              //     ]
              // },
              // markLine: {
              //     data: [{ type: 'average', name: 'Avg' }]
              // }
          }
          
      ]
  };
    myChart.clear();
    myChart.setOption(option);
    // 图表中柱状图点击执行，修改选择月份，传递至父组件
    // myChart.on("click", (obj) => {
    //   const item = dataArry[obj.dataIndex];
    //   if (item) {
    //     this.props.setChooseDate(moment(item.date));
    //   }
    // });
  };

  
  handleClick = () => {
    var data = [];
    var dataSource = JSON.parse(localStorage.getItem('ticketBoardData'));
    var option={};
    let dataTable = [];
    if (dataSource) {
      for (let i in dataSource) {
        let obj = {}
        obj['日期'] = dataSource[i]['date'];
        obj['总工单数'] = dataSource[i]['totalNum'];
        obj['巡检工单数'] = dataSource[i]['xunNum'];
        obj['保养工单数'] = dataSource[i]['careNum'];
        obj['清洁工单数'] = dataSource[i]['cleanNum'];
        obj['调试工单数'] = dataSource[i]['tiaoNum'];
        obj['验收工单数'] = dataSource[i]['yanNum'];
        obj['通用工单数'] = dataSource[i]['commonNum'];
        obj['充电桩故障工单数'] = dataSource[i]['stubNum'];
        obj['地锁故障工单数'] = dataSource[i]['lockNum'];
        dataTable.push(obj);
      }
    }
    var header = ['日期', '总工单数', '巡检工单数', '保养工单数', '清洁工单数', '调试工单数', '验收工单数', '通用工单数', '充电桩故障工单数', '地锁故障工单数'];
    option.fileName = '设备状态导出'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart();
        } else {
          this.initTableConfig();
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className='section'>
        <div style={{display:"flex", alignItems:"center"}}> 
          <div style={{fontSize:"18px", fontWeight:"500", marginRight:"10px"}}>工单分类统计<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内各工单类型创建的数量且占总工单数的比例</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip></div>
          {/* <div style={{color:"#5584ff", cursor:"pointer"}}
                  
                  onClick={() => {
                    this.modalVisibleAction("statusLogVisible", true);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div> */}
        </div>


        <div style={{width:"100%", overflow:"hidden", whiteSpace:"nowrap", margin:"10px 0", overflowX:"auto", paddingBottom:"5px"}}>

            {this.state.gridData.map((d, index) => (
            // <Option key={d.value}>{d.text}</Option>

            <div onClick={(e) => {
              // this.setState({
              //   chooseIndex:index,
              //   areaId:d.id
              // })
              // console.info('啊呜：' + this.state.areaId)
              // RefreshGrid(this.context.store, "moduleStatusLog", {areaId:d.id})
            }} style={{cursor:"pointer", display:"inline-block",border:"1px solid #7da6ff !important", width:"150px", height:"80px", padding:"10px 10px", marginRight:"10px", backgroundColor:"rgb(246 248 251)"}}>
            <div style={{fontSize:"14px"}}>{d.text}</div>
            <div className='num' style={{display:"flex", justifyContent:"space-between", marginTop:"10px"}}>
                      <div>{d.num}</div>
                      <div style={{fontSize:"14px", color:"#a9a1a1"}}>{d.rate}%</div>
                    </div>
        </div>
          ))}
            
          </div>
          <div className='title-box' style={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
            
            <div className='btn-switch-box'>
                <span
                  className={this.state.btnType === 1 && "selected-btn"}
                  onClick={() => this.btnChange(1)}>
                  图
                </span>
                <span
                  className={this.state.btnType === 2 && "selected-btn"}
                  onClick={() => this.btnChange(2)}>
                  表
                </span>
              </div>
            <div style={{    display: 'flex',alignItems: 'center'}}>
                <Button
                onClick={this.handleClick}
                type="primary"
                style={{ margin: "5px" }}>
                导出
              </Button>
              </div>
          </div>
          {this.state.btnType === 1 ? (
            <div
              style={{ width: "100%", height: 420, overflowY: "auto" }}
              id={this.props.chartId || "ticketNum-page-char"}
            />
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default TicketNumCount;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/ticketNumCount.js